'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navDividerClassNames: function() {
        return navDividerClassNames;
    },
    useNavDividerStyles_unstable: function() {
        return useNavDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdivider = require("@fluentui/react-divider");
const navDividerClassNames = {
    root: 'fui-NavDivider',
    wrapper: 'fui-NavDivider__wrapper'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bh6795r: "f1jhi6b8",
        B6of3ja: "fvjh0tl",
        jrapky: "fd1gkq"
    }
}, {
    d: [
        ".f1jhi6b8{flex-grow:0;}",
        ".fvjh0tl{margin-top:4px;}",
        ".fd1gkq{margin-bottom:4px;}"
    ]
});
const useNavDividerStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navDividerClassNames.root, styles.root, state.root.className);
    state.wrapper.className = (0, _react.mergeClasses)(navDividerClassNames.wrapper, state.wrapper.className);
    (0, _reactdivider.useDividerStyles_unstable)(state);
    return state;
};
